// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__B0pWQ","compactWrapper":"styles_compactWrapper__Hd75f","mainSection":"styles_mainSection__sSPY9"};